import React from 'react';
import { motion } from 'framer-motion';
export const ChaptersSection = () => {
  const chapters = [{
    num: 1,
    title: 'Por qué no te están comprando',
    subtitle: 'La verdad incómoda',
    desc: 'Las 5 causas reales de la parálisis comercial y cómo identificar cuál es la tuya en menos de 10 minutos. Dejás de culpar al mercado y empezás a atacar el problema real.'
  }, {
    num: 2,
    title: 'El mapa del dinero escondido',
    subtitle: 'Dónde están los clientes que sí pueden pagarte hoy',
    desc: 'Los 4 tipos de clientes activos en un mercado recesivo y cómo encontrarlos. Incluye el cliente más subestimado: el que ya te conoce y está esperando que le escribas.'
  }, {
    num: 3,
    title: 'La ingeniería de la oferta irresistible',
    subtitle: 'Cómo empaquetar tu servicio para que sea imposible decir no',
    desc: 'El sistema de 4 capas para transformar tu servicio en un resultado específico, medible y urgente. La estrategia del menú de 3 opciones que hace que el cliente pase de "¿compro o no?" a "¿cuál de los tres tomo?".'
  }, {
    num: 4,
    title: 'El sistema de reactivación de muertos',
    subtitle: 'Cómo despertar a los que te ignoraron o desaparecieron',
    desc: 'Los scripts exactos para escribirle a ex-clientes, presupuestos fantasma y conocidos tibios sin sonar desesperado. El sistema de seguimiento de 5 contactos que cierra el 80% de las ventas perdidas.'
  }, {
    num: 5,
    title: 'El guion anti-objeciones de crisis',
    subtitle: 'Qué decir cuando te dicen "no tengo plata"',
    desc: 'Las 6 objeciones más comunes en crisis y la respuesta exacta para cada una. Por qué nunca debés responder "caro" con descuento automático y qué hacer en cambio.'
  }, {
    num: 6,
    title: 'El plan de acción de 30 días',
    subtitle: 'Tu hoja de ruta para salir de la parálisis comercial',
    desc: 'Un plan día por día durante 4 semanas con tareas específicas y tiempos estimados. Al día 30 tenés al menos 1 cliente nuevo cerrado y un sistema funcionando.'
  }];
  return <section className="py-24 bg-white border-y border-neutral-200" data-id="element-40">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-43">
            Adentro de CAJA DE COBRO vas a encontrar:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-44">
          {chapters.map((ch, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream rounded-xl p-6 sm:p-8 border border-neutral-200 hover:border-brand-400 hover:shadow-md transition-all group" data-id="element-45">
              <div className="flex items-start gap-4" data-id="element-46">
                <div className="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-neutral-200 group-hover:bg-brand-600 group-hover:border-brand-600 transition-colors shadow-sm" data-id="element-47">
                  <span className="text-xl font-bold text-brand-600 group-hover:text-white" data-id="element-48">
                    0{ch.num}
                  </span>
                </div>
                <div data-id="element-49">
                  <h3 className="text-xl font-bold text-neutral-900 mb-1 flex items-center gap-2" data-id="element-50">
                    📖 {ch.title}
                  </h3>
                  <p className="text-brand-600 font-medium text-sm mb-4" data-id="element-51">
                    ({ch.subtitle})
                  </p>
                  <p className="text-neutral-700 leading-relaxed" data-id="element-52">{ch.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};